import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from "jquery";
import "slick-carousel";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import BackButton from "./Backbutton";
import RippleInitializer from "./RippleInitializer";
import Title from "./Title";
import { apiHandler } from "../../utils/apiHandler";
import { useParams } from "react-router-dom";
import { EVENT_BASEURL } from "../../utils/Constants";
import PageHeading from "../common/PageHeading";

const Groomsquad = () => {
  // const images = [
  //   {
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //     title: "Priynka Shingvi 1",
  //     text: "could not be happiner than you on your weddiing day. you deserve all the love and happenines in the world and i am honored to stand by your side as you marry the love if your life ould not be happiner than you on your weddiing day. you deserve all the love and happenines in the world and i am honored to stand by your side as you marry the love if your life..",
  //   },
  //   {
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //     title: "Image 1 1",
  //     text: "2Lorem ipsum...overflow-hidden Groomsquad items-center justify-center overflow-hidden Groomsquad items-center justify-center Lorem ipsum...overflow-hidden Groomsquad items-center justify-center overflow-hidden Groomsquad items-center justify-center",
  //   },

  //   {
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //     title: "Image 1 2",
  //     text: "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before the final copy is",
  //   },
  //   {
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //     title: "Image 1",
  //     text: "Lorem ipsum...overflow-hidden Groomsquad items-center justify-center overflow-hidden Groomsquad items-center justify-center Lorem ipsum...overflow-hidden Groomsquad items-center justify-center overflow-hidden Groomsquad items-center justify-center",
  //   },

  //   {
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //     title: "Image 1",
  //     text: "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before the final copy is",
  //   },
  //   {
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //     title: "Image 1",
  //     text: "Lorem ipsum...overflow-hidden Groomsquad items-center justify-center overflow-hidden Groomsquad items-center justify-center Lorem ipsum...overflow-hidden Groomsquad items-center justify-center overflow-hidden Groomsquad items-center justify-center",
  //   },

  //   {
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //     title: "Image 1",
  //     text: "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before the final copy is",
  //   },
  //   {
  //     backgroundUrl: "/img/weddingimage4.jpg",
  //     title: "Image 1",
  //     text: "Lorem ipsum...overflow-hidden Groomsquad items-center justify-center overflow-hidden Groomsquad items-center justify-center Lorem ipsum...overflow-hidden Groomsquad items-center justify-center overflow-hidden Groomsquad items-center justify-center",
  //   },
  // ];


  const { id } = useParams();
  const [images, setImages] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);
  const [showImage, setShowImage] = useState(false);
  const slidesRef = useRef([]);
  const [scrollDirection, setScrollDirection] = useState("down");
  const [direction, setDirection] = useState("");
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const scrollPosition = useRef(window.scrollY);
  const [isImageLoaded, setIsImageLoaded] = useState(true);
  const observerRef = useRef(null);
  const swiperRef = useRef(null);
  const [isFirstClick, setIsFirstClick] = useState(true);
  let NewUsername = "";

  const pathArray = window.location.pathname.split("/").filter(Boolean);

  if (pathArray.includes("Login")) {
    // Handle special case when URL contains "Login"
    NewUsername = pathArray[1];
  } else {
    NewUsername = pathArray[0]
  }

  let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
  const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
  console.log(newImgUrl);

  useEffect(() => {
    const fetchSquad = async () => {
      try {
        const res = await apiHandler.post("/guest/fetch-feature", {
          _id: id,
          category: "FriendSquad"
        });
        console.log(res);
        if (res) {
          const data = res.squadFriendsList.map((item, index) => ({
            backgroundUrl: `${newImgUrl + item.img}`,
            title: item.name,
            text: item.blessing
          }));
          if (window.innerWidth >= 1024) {
            setImages(data.slice(1));

          } else {
            setImages(data);
          }

        }
      } catch (err) {
        console.error("Guest login error:", err);
      }
    };

    fetchSquad();
  }, [])


  const handleTouchMove = (swiper) => {
    if (swiper.touches.diff > 0) {
      setDirection("down");
    } else if (swiper.touches.diff < 0) {
      setDirection("up");
    } else {
      setDirection("nothing");
    }
  };
  const handleclick = () => {
    setDirection("nothing");
  };

  useEffect(() => {
    const handlePopState = () => {
      setDirection("nothing");
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState); // Clean up the event listener
    };
  }, []);

  const settings = {
    className: "center",
    centerMode: false,
    infinite: false,
    speed: 1000,
    dots: true,
    focusOnSelect: true,
    slidesToShow: 1,
    slidesToScroll: 1,


    beforeChange: (current, next) => {
      setCurrentSlide(next);
      scrollDots(current);
    },
    afterChange: (current) => { },
  };

  const scrollDots = (index) => {
    const slickDots = $(".slick-dots");
    const dotWidth = slickDots.find("li").outerWidth(true);
    const dotsVisible = 2; // Number of dots you want visible at a time
    const scrollPosition = (index - Math.floor(dotsVisible / 2)) * dotWidth;

    slickDots.animate({ scrollLeft: scrollPosition }, 300);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowImage(true);
    }, 10);

    return () => clearTimeout(timer);
  }, [images]);

  useEffect(() => {
    const slickDots = $(".slick-dots");
    const handleScroll = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    slickDots.on("scroll", handleScroll);

    return () => {
      slickDots.off("scroll", handleScroll);
    };
  }, [images]);

  useEffect(() => {
    const slides = document.querySelectorAll(".swiper-slide");

    console.log("direction", direction);

    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const slide = entry.target;
          const index = parseInt(slide.dataset.index, 10);
          const opacity = entry.intersectionRatio;
          const div = slide.querySelector(".imagestylegrrom");
          if (!div) return;

          let topPosition = "0%";
          if (direction === "down") {
            topPosition =
              index === activeSlideIndex
                ? `${45 * (1 - opacity)}%`
                : index === activeSlideIndex - 1
                  ? `-45%`
                  : "45%";
          } else if (direction === "up") {
            topPosition =
              index === activeSlideIndex
                ? `-${45 * (1 - opacity)}%`
                : index === activeSlideIndex - 1
                  ? `-45%`
                  : "45%";
          } else {
            topPosition = "0%";
          }

          slide.style.opacity = opacity;
          div.style.top = topPosition;
        });
      },
      {
        root: null,
        threshold: Array.from(Array(101).keys(), (x) => x / 100),
      }
    );

    slides.forEach((slide) => {
      observerRef.current.observe(slide);
    });

    return () => {
      slides.forEach((slide) => {
        observerRef.current.unobserve(slide);
      });
    };
  }, [images, direction, activeSlideIndex]);

  const handleSlideChange = (swiper) => {
    setActiveSlideIndex(swiper.activeIndex);

    const slides = document.querySelectorAll(".swiper-slide");
    slides.forEach((slide, index) => {
      const div = slide.querySelector(".imagestylegrrom");
      if (div) {
        if (index === swiper.activeIndex) {
          div.style.transition = "168ms ";
          div.style.top = "0";
          requestAnimationFrame(() => { });
        } else {
          div.style.top = "0"; // Reset top to 0 for non-active slides
          div.style.transition = "0.5s";
        }
      }
    });
  };

  const handleNextClick = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }

    if (isFirstClick) {
      setDirection("down");
      setIsFirstClick(false);
    }
  };

  console.log("images :", images);

  return (
    <div
      className=" grid-cols-12  overflow-hidden  items-center justify-center bg-white groompage "
      style={{ zIndex: "999", height: "100svh" }}
    >
      <RippleInitializer />
      <div className="flex-row flex-wrap grid grid-cols-12  overflow-hidden Groomsquad items-center justify-center hideinmobile ">
        <div className="col-span-12   md:col-span-5  relative  overflow-hidden  " style={{ height: "100svh" }}>
          {images.map((image, index) => (
            <img
              key={index}
              src={image.backgroundUrl}
              alt={image.title}
              className={`  crossFade__image ${currentSlide === index ? 'crossFade__image--active' : ''
                }
											transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                }
											`}
              onLoad={() => setIsImageLoaded(false)}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ))}
          <div
            className="absolute top-[40px] right-[40px] bottom-[40px] left-[40px] bg-white/0 py-[30px] px-[40px] border-[3px] border-white"
            style={{
              boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.7)",
            }}
          ></div>
        </div>

        <div
          className=" scroll-bar col-span-12 md:col-span-7 px-0  justify-center items-center "
          style={{ height: "100svh" }}
        >
          <div
            className="flex flex-col justify-center items-center "
            style={{ position: "relative", top: "10px", width: "auto" }}
          >
            <Title title={"Groom Squad"} textColor="text-black" />

          </div>

          <Slider ref={sliderRef} style={{ width: "100%" }} {...settings}>
            {images.map((data, index) => (
              <div
                key={index}
                className=" p-5 
                 innerdivGroomSquad "
                style={{ width: "100%", padding: "" }}
              >
                <div
                  className=" flex justify-center flex-col items-center cardofslider "
                  style={{
                    width: "100%",
                    maxHeight: "45vh",
                    top: "2rem",
                    position: "relative",
                  }}
                >
                  <div
                    className="p-4 flex justify-center flex-col items-center text-justify innerdivofcard "
                    style={{
                      border: "3px solid black",
                      width: "65%",
                      borderRadius: "25px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className={`overlayin ${showImage ? "show" : ""}`}
                      style={{
                        backgroundImage: `url(${data.backgroundUrl})`,
                        overflow: "hidden",
                      }}
                    ></div>{" "}
                    <div
                      className="p-1 style-script-regular "
                      style={{ fontWeight: "550", fontSize: "45px" }}
                    >
                      {data.title}
                    </div>
                    <div
                      className="pt-3"
                      style={{
                        textAlign: "justify",
                        lineHeight: "30px",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 5, // Adjust the number of lines you want to show
                        fontSize: "20px"
                      }}
                    >
                      {data.text}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>

          <div className="prevnetx" >
            <button
              className={`button1  whiteripple ${currentSlide === 0 ? "disabled" : ""}`}
              onClick={() => sliderRef.current.slickPrev()}
              style={{
                opacity: currentSlide === 0 ? 0 : 1, // Fade out when on the first slide
                transition: "opacity 0.3s ease-in-out", // Smooth fade effect
              }}
              disabled={currentSlide === 0} // Optional: Disable the button when on the first slide
            >
              <img
                className="p-2"
                style={{
                  filter: "invert(1) sepia(1) saturate(10) hue-rotate(180deg)",
                }}
                src="/img/ic_prev.svg"
                alt=""
              />
            </button>
            <button
              className={`button2 whiteripple ${currentSlide === images.length - 1 ? "disabled" : ""}`}
              onClick={() => sliderRef.current.slickNext()}
              style={{
                opacity: currentSlide === images.length - 1 ? 0 : 1, // Set opacity to 0 when on the last slide
                transition: "opacity 0.3s ease-in-out", // Smooth fade effect
              }}
              disabled={currentSlide === images.length - 1} // Optional: Disable the button when on the last slide
            >
              <img
                className="p-2"
                style={{
                  height: "50px",
                  filter: "invert(1) sepia(1) saturate(10) hue-rotate(180deg)",
                }}
                src="/img/ic_next.svg"
                alt=""
              />
            </button>

          </div>
        </div>
      </div>
      <div className="Groomsquad1 slider-container p-0 ">
        <Swiper
          direction="vertical"
          slidesPerView={1}
          spaceBetween={0}
          onTouchMove={handleTouchMove}
          onSlideChange={handleSlideChange}
          style={{ height: "100svh", padding: '0px' }}
          ref={swiperRef} // Get the swiper instance
        >
          {images.map((image, index) => (
            <SwiperSlide
              key={index}
              data-index={index}
              ref={(el) => (slidesRef.current[index] = el)}
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100svh",
                transition: "opacity 0.5s ease",
              }}
            >
              <div className=" flex flex-col h-screen p-0">
                <div
                  className="imagestylegrrom relative overflow-hidden flex-grow"
                  style={{
                    top: "0",
                  }}
                >
                  <img
                    src={image.backgroundUrl}
                    alt={image.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    className={`
											transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                      }
											`}
                    onLoad={() => setIsImageLoaded(false)}
                  />
                  <div
                    className="absolute top-[33px] right-[33px] bottom-[33px] left-[33px] bg-white/0 py-[30px] px-[33px] border-[3px] border-white "
                    style={{
                      boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.7)",
                    }}
                  ></div>
                </div>
                <div className="grromsquadinnerdiv flex-shrink-0 flex flex-col justify-center items-center p-2 px-2 ">
                  <div
                    className="style-script-regular p-2 pt-4"
                    style={{ fontWeight: "600", fontSize: "42px" }}
                  >
                    {image.title}
                  </div>
                  <div className="p-2">
                    <img
                      className="mobileversion"
                      style={{
                        position: "relative",
                        height: "1.6rem",
                      }}
                      src="/img/ic_weddingline.svg"
                      alt=""
                    />
                  </div>

                  <p
                    className="mb-0 textsmall"
                    style={{
                      fontSize: "1rem",
                      fontWeight: "500",
                      textAlign: "justify",
                      padding: "10px",
                    }}
                  >
                    {image.text}
                  </p>
                </div>
                <div
                  className="imagestylegrrom2  flex-shrink-0 px-3 pb-3 relative overflow-hidden flex justify-center "
                  style={{ width: "100%", bottom: "0" }}
                >
                  {activeSlideIndex === images.length - 1 ? (
                    <BackButton
                      style={{
                        width: "100%",
                        bottom: "0px",
                      }}
                    >
                      <button
                        onClick={handleclick}
                        className="bg-black hover:bg-blue-700  text-white py-2.5 px-5 rounded-3 buttonripple"
                        style={{
                          width: "100%",
                          fontSize: "18px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        Exit
                      </button>
                    </BackButton>
                  ) : (
                    <button
                      className="whiteripple bg-black hover:bg-blue-700 text-white py-2.5 px-5 rounded-3 "
                      style={{
                        width: "100%",
                        // bottom: "20%",
                        fontSize: "18px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                      }}
                      onClick={handleNextClick}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

    </div>
  );
};

export default Groomsquad;
